import { connect } from 'react-redux';

import { INSPECTORS_BLOCK_ID, getInspectorBlockId } from 'KnmPmPackage/MainModule/constants/knmPmFieldsElementsIds';
import { PM_INSPECTORS } from 'CorePackage/MainModule/routes/routes';
import { ErknmInspectors } from 'KnmErknmPackage/ErknmInspectors/components/ErknmInspectors';
import {
  getKnmErknmParticipantPositionsSelectOptions,
  getKnmIsErknmStatusApproving,
  getKnmIsErknmStatusTypeCantBeCarryOut,
  getKnmIsErknmStatusTypeCompleted,
  getKnmIsNeedActSaveOrSign,
} from 'KnmPackage/MainModule/selectors/knmSelectors';
import { IParticipantPosition } from 'APIPackage/DictionariesModule/interfaces/IParticipantPosition';
import { IDictionarySelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySelectOption';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import { getTitleFieldWithRedStar } from '../../../functions/getTitleFieldWithRedStar';

interface IPmInspectorsProps {
  className?: string;
  watchOnly: boolean;
}

interface IPmInspectorsWithoutStore {
  positionsSelectOptions: IDictionarySelectOption<IParticipantPosition>[] | undefined;
  isNeedActSaveOrSign?: boolean;
  isKnmStatusApproving: boolean;
  isKnmStatusCompleted: boolean;
  isKnmStatusTypeCantBeCarriedOut: boolean;
}

const PmInspectorsWithoutStore = ({
  className = '',
  watchOnly,
  positionsSelectOptions,
  isNeedActSaveOrSign = false,
  isKnmStatusApproving,
  isKnmStatusCompleted,
  isKnmStatusTypeCantBeCarriedOut,
}: IPmInspectorsProps & IPmInspectorsWithoutStore) => {
  return (
    <div className={className} id={PM_INSPECTORS}>
      <h2 className="shared-title__with-margin">
        Сведения о должностных лицах контрольных (надзорных) органов, участвующих в соответствующих профилактических
        мероприятиях
      </h2>

      <ErknmInspectors
        watchOnly={
          watchOnly ||
          isKnmStatusApproving ||
          isKnmStatusCompleted ||
          isNeedActSaveOrSign ||
          isKnmStatusTypeCantBeCarriedOut
        }
        name="inspectorsErknm"
        title={
          <>
            {getTitleFieldWithRedStar({
              label:
                'Сведения о должностных лицах контрольных (надзорных) органов, участвующих в соответствующих профилактических мероприятиях',
              field: `inspectorsErknm`,
              isPm: true,
            })}
          </>
        }
        positionsSelectOptions={positionsSelectOptions}
        blockId={INSPECTORS_BLOCK_ID}
        getItemBlockId={getInspectorBlockId}
      />
    </div>
  );
};

const mapStateToProps = (state: IRootState): IPmInspectorsWithoutStore => ({
  positionsSelectOptions: getKnmErknmParticipantPositionsSelectOptions(state),
  isNeedActSaveOrSign: getKnmIsNeedActSaveOrSign(state),
  isKnmStatusApproving: getKnmIsErknmStatusApproving(state),
  isKnmStatusCompleted: getKnmIsErknmStatusTypeCompleted(state),
  isKnmStatusTypeCantBeCarriedOut: getKnmIsErknmStatusTypeCantBeCarryOut(state),
});

export const PmInspectors = connect(mapStateToProps)(PmInspectorsWithoutStore);
